{
    "warning": "ಎಚ್ಚರಿಕೆ!",
    "message": "ನಿಮಗೆ ಅರ್ಥವಾಗದ ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಬೇಡಿ ಅಥವಾ ಅಂಟಿಸಬೇಡಿ.\nಈ ಕನ್ಸೋಲ್ ಬಳಸುವುದರಿಂದ ದಾಳಿಕೋರರು ನಿಮ್ಮಂತೆ ಸೋಗು ಹಾಕಲು ಮತ್ತು Self-XSS ಎನ್ನುವ ಒಂದು ದಾಳಿಯನ್ನು ಬಳಸಿಕೊಂಡು ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ಕದಿಯಲು ಅವಕಾಶ ಮಾಡಿಕೊಡಬಹುದು."
}
